export default function CsPenetrationTestingSocialEngineering() {
  return (
    <h2>Cs Penetration Testing Social Engineering</h2>
  );
}
